<template>
  <div>
    <div class="content-1">{{ $t("successTransactionVue.msg") }}</div>
    <div class="content-2"><img :src="require('@/assets/welcome/ic-16-yipps@3x.png')">&nbsp;&nbsp;{{ yippsPoint }}</div>
  </div>
</template>

<script>
export default {
  props: {
    yippsPoint: {
      type: String,
      default: '0'
    }
  }
}
</script>

<style scoped>
.content-1{
  height: 80px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.content-2{
  font-size: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
